import { API_ORDER_ITEM } from '@/api/apiRoutes'
import api from '@/lib/api'
import { IOrderResponse } from '@/types/Order'
import { getHeaderToken } from '@/utils/getHeaderToken'

interface Body {
  plan: number
  domain?: string
}

export const orderItem = async (body: Body, token: string) => {
  try {
    const { data } = await api.post<IOrderResponse>(API_ORDER_ITEM, body, {
      headers: getHeaderToken(token),
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}
